(function (Drupal, $, once) {

  if (typeof $.type === 'undefined') {
    $.type = function(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
}

  Drupal.behaviors.orlogshemmetMegaMenuToggle = {
    attach: function () {
      const $region = $('.mega-menu');
      const $button = $('.toggle-mega-menu');

      $(once('orlogshemmetMenuToggle', $button)).on('click', function() {
        let ariaExpanded = $(this).attr('aria-expanded');
        $('html').toggleClass('show-mega-menu');

        if (ariaExpanded === 'true') {
          $(this).attr('aria-expanded', 'false');

          $region.focus();
        } else {
          $(this).attr('aria-expanded', 'true');
        }
      });

      // Listen to keypress
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
          let ariaExpanded = $button.attr('aria-expanded');

          if (ariaExpanded === 'true') {
            $('html').removeClass('show-mega-menu');
            $button.attr('aria-expanded', 'false');
          }
        }
      });
    }
  };
})(Drupal, jQuery, once);